import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AppLoadingStateService {

    public readonly TAG: string = "[AppLoadingStateService]";

    private _leftColumnLoaded: boolean = false;
    private _mainViewLoaded: boolean = false;
    private _headerLoaded: boolean = false;
    private _devisLoaded: boolean = false;

    public loadState: boolean = false;

    public subject: Subject<boolean> = new Subject<boolean>();

    public observable: Observable<boolean> = this.subject.asObservable();

    constructor() {}

    private detectState(): void
    {
        console.log(this.TAG, "detectState", "- left column loaded:", this.leftColumnLoaded, "- main view loaded:", this.mainViewLoaded, "- header column loaded:", this.headerLoaded);

        this.loadState = this.leftColumnLoaded && this.mainViewLoaded && this.headerLoaded && this.devisLoaded;

        this.subject.next(this.loadState);
    }

    public set leftColumnLoaded(pValue: boolean)
    {
        if (this._leftColumnLoaded === pValue)     { return; }

        this._leftColumnLoaded = pValue;

        this.detectState();
    }

    public set devisLoaded(pValue: boolean)
    {
        if (this._devisLoaded === pValue)     { return; }

        this._devisLoaded = pValue;

        this.detectState();
    }

    public get devisLoaded(): boolean
    {
        return this._devisLoaded;
    }

    public get leftColumnLoaded(): boolean
    {
        return this._leftColumnLoaded;
    }

    public set mainViewLoaded(pValue: boolean)
    {
        if (this._mainViewLoaded === pValue)     { return; }

        this._mainViewLoaded = pValue;

        this.detectState();
    }

    public get mainViewLoaded(): boolean
    {
        return this._mainViewLoaded;
    }

    public set headerLoaded(pValue: boolean)
    {
        if (this._headerLoaded === pValue)     {return; }

        this._headerLoaded = pValue;

        this.detectState();
    }

    public get headerLoaded(): boolean
    {
        return this._headerLoaded;
    }
}



// WEBPACK FOOTER //
// ./src/app/app-loading-state.service.ts